import './EditPage.scss';

export { default } from './EditPage';
